export const SmallWidgetsData = [
  {
    gateColor: "#dceffe",
    title: "Gate #1",
    color: "primary",
    total: 48,
    gros: 50,
    icon: "new-order",
  },
  {
    title: "Gate #2",
    gateColor: "#fde5d8",
    color: "warning",
    total: 47,
    gros: 20,
    icon: "customers",
  },
  {
    title: "Gate #3",
    gateColor: "#dbf8e6",
    color: "secondary",
    total: 47,
    gros: 10,
    // prefix: "$",
    icon: "sale", 
  },
  {
    title: "Gate #4",
    gateColor: "#f6d8fe",
    color: "success",
    total: 47,
    gros: 80,
    // prefix: "$",
    icon: "profit",
  },
];

export const SmallWidgetsData1 = [
  {
    gateColor: "#dceffe",
    title: "Gate #1",
    color: "primary",
    total: 90,
    gros: 30,
    icon: "new-order",
  },
  {
    title: "Gate #2",
    gateColor: "#fde5d8",
    color: "warning",
    total: 96,
    gros: 30,
    icon: "customers",
  },
  {
    title: "Gate #3",
    gateColor: "#dbf8e6",
    color: "secondary",
    total: 34,
    gros: 10, 
    icon: "sale", 
  },
  {
    title: "Gate #4",
    gateColor: "#f6d8fe",
    color: "success",
    total: 77,
    gros: 20,
    // prefix: "$",
    icon: "profit",
  },
];
export const SmallWidgetsData2 = [
  {
    gateColor: "#dceffe",
    title: "Gate #1",
    color: "primary",
    total: 20,
    gros: 25,
    icon: "new-order",
  },
  {
    title: "Gate #2",
    gateColor: "#fde5d8",
    color: "warning",
    total: 16,
    gros: 20,
    icon: "customers",
  },
  {
    title: "Gate #3",
    gateColor: "#dbf8e6",
    color: "secondary",
    total: 44,
    gros: 15,
    // prefix: "$",
    icon: "sale", 
  },
  {
    title: "Gate #4",
    gateColor: "#f6d8fe",
    color: "success",
    total: 27,
    gros: 2,
    // prefix: "$",
    icon: "profit",
  },
];

export const SmallWidgetsData3 = [
  {
    gateColor: "#dceffe",
    title: "Gate #1",
    color: "primary",
    total: 40,
    gros: 55,
    icon: "new-order",
  },
  {
    title: "Gate #2",
    gateColor: "#fde5d8",
    color: "warning",
    total: 23,
    gros: 51,
    icon: "customers",
  },
  {
    title: "Gate #3",
    gateColor: "#dbf8e6",
    color: "secondary",
    total: 66,
    gros: 44, 
    icon: "sale", 
  },
  {
    title: "Gate #4",
    gateColor: "#f6d8fe",
    color: "success",
    total: 22,
    gros: 21, 
    icon: "profit",
  },
];
export const SmallWidgetsData4 = [
  {
    gateColor: "#dceffe",
    title: "Gate #1",
    color: "primary",
    total: 30,
    gros: 5,
    icon: "new-order",
  },
  {
    title: "Gate #2",
    gateColor: "#fde5d8",
    color: "warning",
    total: 21,
    gros: 15,
    icon: "customers",
  },
  {
    title: "Gate #3",
    gateColor: "#dbf8e6",
    color: "secondary",
    total: 46,
    gros: 46, 
    icon: "sale", 
  },
  {
    title: "Gate #4",
    gateColor: "#f6d8fe",
    color: "success",
    total: 88,
    gros: 99, 
    icon: "profit",
  },
];


// ValuableCustomer Dara //
export const ValuableCustomerData = [
  {
    name: "Jane Cooper",
    image: "1.jpg",
    email: "alma.lawson@gmail.com",
  },
  {
    name: " Cameron Willia",
    image: "2.jpg",
    email: "tim.jennings@gmail.com",
  },
  {
    name: "Floyd Miles",
    image: "9.jpg",
    email: "kenzi.lawson@gmail.com",
  },
  {
    name: "Dianne Russell",
    image: "5.jpg",
    email: "curtis.weaver@gmail.com",
  },
  {
    name: "Guy Hawkins",
    image: "3.jpg",
    email: "curtis.weaver@gmail.com",
  },
];

// Recent Order Table //
export const RecentOrderTable = [
  [
    {
      image: "4.png",
      title: "T-shirt",
      id: "#CFDE-2163",
      qty: "X1",
      status: "Verified",
      statusCode: "success",
      price: 56.0,
      total: 100.0,
      iconName: "24-hour",
    },
    {
      image: "3.png",
      title: "Pink T-shirt",
      id: "#CFDE-2780",
      qty: "X2",
      status: "Rejected",
      statusCode: "danger",
      price: 156.0,
      total: 870.0,
      iconName: "24-hour",
    },
  ],
  [
    {
      image: "5.png",
      title: "Sony",
      id: "#CFDE-2163",
      qty: "X1",
      status: "Rejected",
      statusCode: "danger",
      price: 56.0,
      total: 390.0,
      iconName: "24-hour",
    },
    {
      image: "6.png",
      title: "Samsung",
      id: "#CFDE-2780",
      qty: "X2",
      status: "Verified",
      statusCode: "success",
      price: 100.0,
      total: 870.0,
      iconName: "24-hour",
    },
  ],
  [
    {
      image: "1.png",
      title: "Sony",
      id: "#CFDE-2163",
      qty: "X1",
      status: "Verified",
      statusCode: "success",
      price: 56.0,
      total: 100.0,
      iconName: "24-hour",
    },
    {
      image: "2.png",
      title: "Sennheiser",
      id: "#CFDE-2780",
      qty: "X2",
      status: "Rejected",
      statusCode: "danger",
      price: 156.0,
      total: 100.0,
      iconName: "24-hour",
    },
  ],
  [
    {
      image: "7.png",
      title: "Chair",
      id: "#CFDE-2163",
      qty: "X1",
      status: "Verified",
      statusCode: "success",
      price: 48.0,
      total: 50.0,
      iconName: "24-hour",
    },
    {
      image: "8.png",
      title: "Office Chair",
      id: "#CFDE-2780",
      qty: "X2",
      status: "Rejected",
      statusCode: "danger",
      price: 73.0,
      total: 75.0,
      iconName: "24-hour",
    },
  ],
  [
    {
      image: "9.png",
      title: "Lamp",
      id: "#CFDE-2163",
      qty: "X1",
      status: "Verified",
      statusCode: "success",
      price: 20.0,
      total: 25.0,
      iconName: "24-hour",
    },
    {
      image: "10.png",
      title: "Bedside lamp",
      id: "#CFDE-2780",
      qty: "X2",
      status: "Rejected",
      statusCode: "danger",
      price: 70.0,
      total: 88.0,
      iconName: "24-hour",
    },
  ],
];

export const TopCategoriesData = [
  {
    image: "1.png",
    title: "Food & Drinks",
    subTitle: "12,200",
  },
  {
    image: "2.png",
    title: "Furniture",
    subTitle: "7,510",
  },
  {
    image: "3.png",
    title: "Grocery",
    subTitle: "15,475",
  },
  {
    image: "4.png",
    title: "Electronics",
    subTitle: "27,840",
  },
  {
    image: "5.png",
    title: "Toys & Games",
    subTitle: "8,788",
  },
  {
    image: "6.png",
    title: "Desktop",
    subTitle: "10,673",
  },
  {
    image: "7.png",
    title: "Mobile & Accessories",
    subTitle: "5,129",
  },
];

export const RecentActivityData = [
  {
    title: " Added Bew Items",
    date: "8th March, 2022",
    subTitle: "Quisque a consequat ante sit amet magna...",
    image: ["1", "2", "3"],
    status: "primary",
  },
  {
    title: "Anamika Comments this Poducts",
    date: "2nd Sep, Today",
    subTitle: "Quisque a consequat ante sit amet magna...",
    status: "warning",
  },
  {
    title: "Jacksion Purchase ",
    date: "3nd Sep, 2022",
    subTitle: "Quisque a consequat ante sit amet magna...",
    status: "secondary",
  },
  {
    title: "Anamika Comments this Poducts",
    date: "2nd Sep, Today",
    subTitle: "Quisque a consequat ante sit amet magna...",
    status: "success",
  },
];



export const SmallWidgetsDataa = [
  {
    gateColor: "#dceffe",

    title: "Gate #1",
    color: "primary",
    total: 48,
    gros: 50,
    icon: "new-order",
  },
  // {
  //   title: "Gate #2",
  //   gateColor: "#fde5d8",
  //   color: "warning",
  //   total: 47,
  //   gros: 20,
  //   icon: "customers",
  // }
];
export const SmallWidgetsDataaa = [
  {
    gateColor: "#dceffe",

    title: "Gate #1",
    color: "primary",
    total: 48,
    gros: 50,
    icon: "new-order",
  },
  {
    title: "Gate #2",
    gateColor: "#fde5d8",
    color: "warning",
    total: 47,
    gros: 20,
    icon: "customers",
  },
  
];

